// src/App.js
// La tienda pública (catálogo y seguimiento) va en el paquete inicial y no usa
// sesión: el comprador que llega de un anuncio descarga solo la tienda. Login,
// portales y panel están en AppPrivada, un paquete aparte que se carga al
// entrar a cualquiera de esas rutas.
import React, { Suspense, lazy, useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AvisoActualizacion } from './componentes/comunes/AvisoActualizacion';
import { NotificadorGlobal } from './componentes/comunes/Toast';
import { CatalogoPublico } from './componentes/tienda/CatalogoPublico';
import { SeguimientoPedido } from './componentes/tienda/SeguimientoPedido';
import { EnlaceRecepcion } from './componentes/accesos/EnlaceRecepcion';
import './App.css';

// Tras un deploy, una pestaña abierta antes puede pedir un paquete que ya no
// existe: se recarga una sola vez para traer la versión nueva. Si vuelve a
// fallar (sin conexión), el ErrorBoundary muestra el aviso.
const CLAVE_RECARGA = 'agRecargaPaquete';
// Tablet de ingreso (sin sesión): paquete aparte, nunca descarga el panel.
const KioscoIngreso = lazy(() => import('./componentes/accesos/KioscoIngreso'));
const AppPrivada = lazy(() => import('./AppPrivada').then(
  (modulo) => {
    try { sessionStorage.removeItem(CLAVE_RECARGA); } catch (_) {}
    return modulo;
  },
  (error) => {
    let yaRecargo = true;
    try {
      yaRecargo = sessionStorage.getItem(CLAVE_RECARGA) === '1';
      if (!yaRecargo) sessionStorage.setItem(CLAVE_RECARGA, '1');
    } catch (_) {}
    if (yaRecargo) throw error;
    window.location.reload();
    return new Promise(() => {});
  }
));

const CargandoApp = () => (
  <div className="contenedor-carga" role="status">
    <div className="spinner"></div>
    <p>Cargando...</p>
  </div>
);

// ── App raíz ─────────────────────────────────────────────────────────────
function App() {
  const [hayActualizacion, setHayActualizacion] = useState(false);
  const [swRegistration, setSwRegistration]     = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setSwRegistration(e.detail);
      setHayActualizacion(true);
    };
    window.addEventListener('swUpdate', handler);
    return () => window.removeEventListener('swUpdate', handler);
  }, []);

  const handleActualizar = useCallback(() => {
    if (swRegistration && swRegistration.waiting) {
      swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
      swRegistration.waiting.addEventListener('statechange', (e) => {
        if (e.target.state === 'activated') {
          window.location.reload();
        }
      });
    } else {
      window.location.reload();
    }
  }, [swRegistration]);

  return (
    <>
      <Router>
        <Routes>
          <Route path="/catalogo/:gymId" element={<CatalogoPublico />} />
          <Route path="/catalogo/:gymId/pedidos" element={<SeguimientoPedido />} />
          {/* Enlaces antiguos de seguimiento (#clave): llevan a «Mis pedidos» */}
          <Route path="/seguimiento/:gymId" element={<SeguimientoPedido />} />
          {/* QR impreso de recepción leído con la cámara del celular */}
          <Route path="/asistencia/:gymId" element={<EnlaceRecepcion />} />
          <Route path="/kiosco" element={<Suspense fallback={<CargandoApp />}><KioscoIngreso /></Suspense>} />
          <Route path="/*" element={<Suspense fallback={<CargandoApp />}><AppPrivada /></Suspense>} />
        </Routes>
      </Router>
      <AvisoActualizacion mostrar={hayActualizacion} onActualizar={handleActualizar} />
      <NotificadorGlobal />
    </>
  );
}

export default App;
